{
	"common": {
		"bet": "Pronos OWCS",
		"club": "Club",
		"gallery": "Galerie",
		"matches": {
			"lowercase": "matchs/events",
			"titlecase": "Matchs/Events"
		},
		"new": "Nouveau",
		"news": "Actus",
		"partners": "Partenaires",
		"pplace": "pplace",
		"quests": "BattlePEPS",
		"support-us": "Nous soutenir",
		"watch": "Regarder"
	},
	"component": {
		"achievement-row": {
			"achievement": "Palmarès",
			"no-achievements": "Aucun palmarès pour le moment !",
			"text": "\t\t\t\tUt scelerisque erat vel eros accumsan, nec imperdiet mi bibendum. In vel porta tellus. Phasellus sed tellus quis tortor blandit semper. Ut scelerisque erat vel eros accumsan, nec imperdiet mi bibendum. In vel porta tellus. Phasellus sed tellus quis tortor blandit semper. "
		},
		"bet": {
			"card-info": {
				"available": "Prono ouverts - Tu n'as pas encore placé ton prono !",
				"closed": "Ce prono est cloturé",
				"too-late": "Trop tard - Tu n'as pas pronostiqué à temps",
				"unavailable": "Ce prono n'est pas encore disponible",
				"your-prediction": "Ton prono :"
			}
		},
		"bet-current-season": {
			"end-in": "Fin dans",
			"title": "Saison en cours"
		},
		"bet-finished-matchup-card": {
			"closed": "Cloturé"
		},
		"bet-header": {
			"discover": "Découvrir",
			"main-text": "Participe aux pronos et remporte ton maillot de la Team Peps",
			"modal": {
				"leaderboard": {
					"text": {
						"one": "Enchaîne les pronos et défie la communauté pour être le boss de la saison !",
						"three": "Montre ta maîtrise de la scène en partageant tes pronos et tes scores sur le Discord de la Team Peps !",
						"two": "Chaque semaine, tes résultats sont actualisés et ton classement ajusté : chaque point compte !"
					},
					"title": "Le classement"
				},
				"make-bet": {
					"text": {
						"four": "Ton prono est validé ? C’est officiel, aucun retour possible !",
						"one": {
							"make-bet": "Choisis un match, désigne le gagnant et devine le score ! ",
							"ready-to": "Prêts à ",
							"shine": "briller"
						},
						"three": "Les pronos se ferment 10 minutes avant le match, alors ne traîne pas !",
						"two": "Chaque mercredi, les matchs du week-end ouvrent leurs portes !"
					},
					"title": "Faire un prono"
				},
				"points-reward": {
					"points": "points",
					"text": {
						"four": "À la fin de chaque saison, le meilleur de la communauté remporte le ",
						"jersey": "maillot de l'équipe",
						"one": "Choisis le bon gagnant d’un match et gagne",
						"three": "Mauvais choix ? Peu importe le score, tu ne gagnes aucun point !",
						"two": {
							"good-winner-and-good-score": "choisis le bon gagnant, le bon score et gagne ",
							"make-a": "Réalise un "
						}
					},
					"title": "Les points et la récompense"
				},
				"title": "Les pronos de la Team Peps, c'est quoi ?"
			},
			"react": "Réagir",
			"subtext": "Montre ta connaissance de la scène en remportant le tournoi des pronostics de la Team Peps et remporte le maillot de l'équipe !"
		},
		"bet-matchup-card": {
			"already-bet": "Modifier le prono",
			"close-in": "Cloturé dans",
			"closed": "Cloturé",
			"closed-bet": "Pronostic clos",
			"need-login": "Connecte toi pour faire ton prono",
			"open-in": "Ouvert dans",
			"place-bet": "Placer un prono",
			"unavailable-bet": "Pas encore disponible"
		},
		"bet-sidebar": {
			"bet": {
				"error": "Impossible de valider ce prono",
				"success": "Prono validé !"
			},
			"bet-validated": "Prono validé",
			"make-bet": "Faire un prono",
			"valid-bet": "Valider le prono"
		},
		"bet-top-five": {
			"title": "Classement",
			"view-all": "Voir tout"
		},
		"cookie": {
			"accept": "Accepter le cookie",
			"omg": "Omg ce cookie !",
			"question": "Maintenant qu'on l'a, on en fait quoi ?",
			"reject": "Refuser"
		},
		"event-row": {
			"ticket": "Billetterie"
		},
		"footer": {
			"bottom": {
				"all-right": "Team Peps {{year}} - Tous droits réservés",
				"cgu": "Conditions Générales d'Utilisation",
				"privacy": "Politique de confidentialité",
				"read": "Lire les"
			},
			"more": {
				"cgu": "CGU",
				"contact": "Contact",
				"privacy": "Confidentialité",
				"title": "More"
			},
			"powered-by": "Propulsé par",
			"shop": {
				"all-products": "Tous les produits",
				"news": "Nouveautés",
				"offers": "Promotions",
				"title": "Boutique"
			},
			"socials": {
				"title": "Retrouver la Team Peps"
			}
		},
		"gallery-card": {
			"read-more": "Voir les photos"
		},
		"headband-twitch": {
			"title": "Un match est en cours, rejoins nous !"
		},
		"last-videos": {
			"go-to-youtube": "Voir la chaine youtube",
			"subtitle": "Vidéos",
			"title": "Dernières"
		},
		"leaderboard-info": {
			"tooltip-available": "Vous n'avez pas encore placé de prono pour ce match !"
		},
		"match-row": {
			"review": "Revoir",
			"start-in": "Début dans",
			"waiting": "Attendre"
		},
		"member-card": {
			"substitute": "Remplaçant"
		},
		"navbar": {
			"ambassadors": "Ambassadeurs",
			"bet": {
				"betting": "Faire un prono",
				"leaderboard": "Classement"
			},
			"bundle-offer": "Offre exclusive",
			"category-panel": {
				"bet": {
					"leaderboard": {
						"description": "Le classement des pronostics",
						"title": "Classement"
					},
					"make-bet": {
						"description": "Réalise tes pronos de l'OWCS EMEA de la saison en cours",
						"title": "Faire un prono"
					},
					"title": "Pronostics"
				},
				"collection": {
					"marketplace": {
						"description": "Échange tes doublons avec les membres de la communauté",
						"title": "Marketplace"
					},
					"shop": {
						"description": "Ouvre des boosters pour terminer la collection",
						"title": "Boutique"
					},
					"title": "Collection"
				},
				"quests": {
					"description": "Termine ton BattlePeps pour recevoir des récompenses et soutenir la Team Peps",
					"title": "Quêtes"
				}
			},
			"club": {
				"club": "Club",
				"gallery": "Galerie",
				"news": "Actus",
				"title": "Le club"
			},
			"collection": {
				"inventory": "Inventaire",
				"market": "Marché",
				"shop": "Boutique",
				"title": "Collection"
			},
			"game": {
				"title": "Jeux"
			},
			"login": "Connexion",
			"logout": "Déconnexion",
			"merch": "Merch",
			"profile": "Profil",
			"quests": {
				"subtitle": "Quêtes",
				"title": "BattlePeps"
			},
			"team": {
				"dofus": "Dofus",
				"marvel-rivals": "Marvel Rivals",
				"overwatch": {
					"academy": "Overwatch Academy",
					"pro": "Overwatch Pro"
				},
				"pokemon-unite": "POKEMON UNITE",
				"pokemon-vgc": "POKEMON VGC",
				"sport": "Sport",
				"title": "Équipes"
			},
			"ticketing": "Billetterie"
		},
		"navbar-twitch": {
			"live-channels": "Chaines en direct",
			"offline": "Hors ligne",
			"online": "en live",
			"watch": "Regarder"
		},
		"news-card": {
			"read-more": "Lire la suite"
		},
		"no-gallery": {
			"text": "aaargh... Pas de galerie pour le moment"
		},
		"no-news": {
			"text": "aaargh... Pas d'actus pour le moment"
		},
		"no-result-match": {
			"text": "AAARGH... Aucun match ou évènement !"
		},
		"no-upcoming-match": {
			"text": "AAARGH... Aucun match ou évènement n'est prévu pour le moment !"
		},
		"notification-center": {
			"empty": "Aucune notification pour le moment",
			"mark-all-read": "Tout lire",
			"title": "Notifications",
			"view": "Voir"
		},
		"partner-card": {
			"clipboard": {
				"error": "Le code n'a pas été copié !",
				"success": "Code {{code}} copié !"
			},
			"take-offer": "Profiter de l'offre"
		},
		"place-challenge": {
			"title": "Défis"
		},
		"place-information": {
			"first-paragraph": {
				"le": "Le",
				"text": "est une toile collaborative où chaque membre de la communauté peut placer des pixels pour créer, ensemble, une œuvre collective.\n\t\t\t\t\tL'objectif est de soutenir nos joueurs aux Worlds tout en laissant une trace de votre passage sur la toile.\n\t\t\t\t\tChaque pixel posé contribue à la construction d’images, motifs ou créations géantes, et chaque action compte !"
			},
			"fourth-paragraph": {
				"le": "Partage tes créations sur le Discord de la Team Peps pour montrer ton soutien, échanger avec les autres participants, et célébrer les œuvres collectives de la communauté.\n\t\t\t\t\tQui sera le meilleur soutien de la Team Peps ? À toi de jouer !"
			},
			"key-points": {
				"add-pixels-max": "pixels max tous les",
				"available-color": "couleurs disponibles",
				"canvas": "Toile de ",
				"challenges": "Les défis",
				"increase-max": "augmentent ton maximum",
				"of": "de",
				"placed": "posés",
				"recharge-in": "se recharge en",
				"seconds": "secondes",
				"title": "Les points clés"
			},
			"second-paragraph": {
				"text": "Tu commences avec un maximum de 100 pixels à poser. Chaque pixel placé se recharge toutes les 15 secondes, ce qui te permet de continuer à participer progressivement.\n\t\t\t\t\tTon nombre maximum de pixels disponibles augmente tous les 10 pixels posés, ou lorsque tu réalises des défis et débloques des badges exclusifs."
			},
			"third-paragraph": {
				"text": "n’est pas seulement une expérience collaborative : c’est aussi une petite compétition.\n\t\t\t\t\tUn classement indique quels membres posent le plus de pixels et contribuent le plus à la toile.\n\t\t\t\t\tObserve les meilleurs contributeurs, essaie de progresser dans le classement et montre que tu es le plus grand supporter de la Team Peps !"
			},
			"title": "C'est quoi PPlace ?"
		},
		"place-leaderboard": {
			"title": "Classement"
		},
		"twitch-iframe": " La Team Peps est en LIVE",
		"upcoming-matches": {
			"today": "Aujourd'hui",
			"view-all": "Tout voir"
		}
	},
	"notification": {
		"not-supported": "Les notifications ne sont pas supportées par ton navigateur.",
		"permission-denied": "Permission de notification refusée.",
		"subscribed": "Abonnement aux notifications réussi",
		"subscription-error": "Erreur lors de l'abonnement aux notifications",
		"type": {
			"BADGE_UNLOCKED": "Tu as débloqué un nouveau badge !",
			"BATTLEPEPS_RANK_UP": "Nouveau rang Battle Peps : {{ rank }} !",
			"BATTLEPEPS_TIER_REACHED": "Tu as franchi {{ tiersCrossed }} palier(s) et es maintenant au palier {{ tier }} du Battle Peps !",
			"BOOSTER_PURCHASED": "Tu as acheté le booster « {{ boosterName }} ».",
			"BOOSTER_RECEIVED": "Tu as reçu le booster « {{ boosterName }} » !",
			"CARD_PURCHASED": "Tu as acheté la carte « {{ cardName }} » à {{ sellerUsername }} pour {{ price }} PepsCoins.",
			"CARD_RECEIVED": "Tu as reçu la carte « {{ cardName }} » !",
			"CARD_SOLD": "{{ buyerUsername }} a acheté ta carte « {{ cardName }} » pour {{ price }} PepsCoins !",
			"COIN_CREDIT": "Tu as reçu {{ amount }} PepsCoins !",
			"PREDICTION_RESULT": {
				"lost": "Ta prédiction {{ match }} est terminée · aucun point gagné.",
				"won": "Ta prédiction {{ match }} est terminée · +{{ pointsEarned }} point(s) !"
			},
			"QUEST_VALIDATED": "Quête validée : {{ questName }}. Bien joué !",
			"WEEKLY_BOOSTER_OFFERED": "Ton booster hebdomadaire offert « {{ boosterName }} » est disponible !"
		},
		"unsubscribed": "Désabonnement aux notifications réussi",
		"unsubscription-error": "Erreur lors du désabonnement aux notifications"
	},
	"page": {
		"ambassadors": {
			"followers": {
				"count": "5 millions",
				"text": "Followers"
			},
			"seo-description": "Les ambassadeurs et créateurs de contenu qui représentent les couleurs de la Team Peps.",
			"seo-title": "Team Peps - Ambassadeurs",
			"text": "Nos premiers supporters, nos plus grands analystes, nos spécialistes de l'impro et des contenus les plus fous, découvrez les ambassadeurs de la Team Peps !",
			"title": "Team Peps - Ambassadeurs"
		},
		"battlepeps": {
			"dev": {
				"skip": "Passer un palier (dev)",
				"skip-success": "Palier passé !"
			},
			"errors": {
				"load": "Impossible de charger le Battle Peps."
			},
			"global-quests": {
				"button": "Participer à la quête collective",
				"title": "Quêtes collectives"
			},
			"global": {
				"reward": "Récompense :"
			},
			"leaderboard": {
				"xp": "XP"
			},
			"login-required": {
				"cta": "Se connecter avec Twitch",
				"text": "Connecte-toi avec Twitch pour suivre ton palier, tes récompenses et tes quêtes.",
				"title": "Connecte-toi pour voir ta progression"
			},
			"no-season": {
				"text": "Aucune saison Battle Peps en cours"
			},
			"progress": {
				"max-rank": "Rang maximum atteint",
				"rank": "Rang actuel",
				"rank-bonus-tooltip": "{{rank}} : +{{bonus}}% d'XP sur chaque quête complétée",
				"tier": "Palier"
			},
			"quests": {
				"auto-verification": "Détection automatique — aucune action requise ici",
				"declare": "Je l'ai fait",
				"declare-error": "Impossible de déclarer cette quête.",
				"empty": "Aucune quête disponible pour le moment.",
				"history": {
					"empty": "Aucune quête validée pour l'instant.",
					"title": "Historique"
				},
				"image-invalid-type": "Format non supporté (jpg, jpeg ou png uniquement).",
				"image-too-large": "Image trop volumineuse (20 Mo max).",
				"pending-title": "En attente de validation",
				"scope": {
					"daily": "Quotidien",
					"monthly": "Mensuel",
					"one-time": "Unique",
					"per-stream": "1x par live",
					"repeatable": "Répétable"
				},
				"status": {
					"pending": "En attente de validation",
					"rejected": "Refusée",
					"validated": "Validée"
				},
				"tip-role-tiers-title": "XP selon ton rôle Tipeee",
				"title": "Quêtes",
				"upload-proof": "Envoyer une preuve avec le pseudo visible",
				"verify": "Valider",
				"verify-discord-required": "Lie ton compte Discord pour valider cette quête.",
				"verify-error": "Impossible de valider cette quête.",
				"verify-not-fulfilled": "Tu n'es pas encore sur le Discord, rejoins-le puis réessaie.",
				"verify-not-fulfilled-follow-twitch": "Tu ne suis pas encore la chaîne Twitch. Suis-la puis réessaie.",
				"verify-not-fulfilled-sub-youtube": "Tu n'es pas encore abonné à la chaîne YouTube de fefegg. Abonne-toi puis réessaie.",
				"verify-not-fulfilled-tip-role": "Tu ne possèdes pas encore ce rôle Discord. Réessaie une fois le rôle attribué par Tipeee.",
				"verify-youtube-denied": "Vérification YouTube annulée.",
				"verify-youtube-failed": "La vérification YouTube a échoué. Réessaie plus tard.",
				"verify-youtube-success": "Abonnement YouTube vérifié, quête validée !"
			},
			"ranks": {
				"title": "Rangs"
			},
			"rewards": {
				"claim": "Réclamer",
				"claim-all": "Tout réclamer",
				"claim-all-success": "{{count}} récompense(s) réclamée(s) !",
				"claim-error": "Impossible de réclamer cette récompense.",
				"claim-success": "Récompense réclamée !",
				"claimed": "Réclamé",
				"current": "Actuel",
				"empty": "Aucun palier franchi pour l'instant.",
				"tier": "Palier {{tier}}",
				"title": "Récompenses de palier",
				"type": {
					"booster": "Booster",
					"coins": "PepsCoins"
				}
			},
			"season": {
				"ended": "Terminée",
				"ends-in": "Fin dans :"
			},
			"title": "BATTLE PEPS",
			"tutorial": {
				"done": "Terminé",
				"header": {
					"text": "Un battle pass saisonnier : gagne de l'XP en regardant les lives, en pariant ou en complétant des quêtes, et débloque des récompenses à chaque palier franchi.",
					"title": "Bienvenue sur le Battle Peps !"
				},
				"leaderboard": {
					"text": "Compare ta progression à celle des autres joueurs de la saison.",
					"title": "Le classement"
				},
				"login": {
					"text": "Connecte-toi avec Twitch pour suivre ta progression, réclamer tes récompenses et compléter des quêtes.",
					"title": "Connecte-toi pour participer"
				},
				"next": "Suivant",
				"prev": "Précédent",
				"quests": {
					"text": "Complète des quêtes pour gagner de l'XP supplémentaire : certaines se valident automatiquement, d'autres nécessitent une preuve à déclarer.",
					"title": "Les quêtes"
				},
				"rank": {
					"text": "Plus ton rang est élevé, plus tu gagnes d'XP bonus sur chaque quête complétée.",
					"title": "Ton rang"
				},
				"replay": "Revoir le tutoriel",
				"rewards": {
					"text": "Chaque palier franchi débloque une récompense (PepsCoins ou booster). Réclame-les dès qu'elles sont disponibles !",
					"title": "Récompenses de palier"
				},
				"xp": {
					"text": "Ta barre d'XP au sein du palier courant. Une fois remplie, tu passes au palier suivant.",
					"title": "Ta progression"
				}
			}
		},
		"bet": {
			"all-match-finished": "Tout les matchs ont été joués",
			"no-match-played": "Aucun match n'a été joué pour le moment !",
			"no-season": "Aucune saison en cours pour le moment.",
			"see-past-season": "Voir les saisons passées",
			"tab": {
				"match-played": "Matchs joués",
				"match-upcoming": "Prochains matchs"
			},
			"title": "Team Peps - Pronos"
		},
		"booster-opening": {
			"close": "Fermer",
			"open-next": "Ouvrir le booster suivant",
			"owned": "possédé en {{score}}",
			"destroy": "Décrafter (+{{coins}} PepsCoins)",
			"destroyed": "Décrafté",
			"destroy-success": "Carte décraftée — +{{coins}} PepsCoins !",
			"destroy-error": "Impossible de décrafter cette carte"
		},
		"callback-code": {
			"login": {
				"failed": "Erreur lors de la connexion !",
				"success": "Connexion réussie"
			}
		},
		"cgu": {
			"article_1": {
				"content": "L’édition du site teampeps.fr / teampeps.com est assurée par la “Team Peps” enregistrée à l’INPI sous le numéro 5075453.   \n\nAdresse e-mail : contact.teampeps@gmail.com \n\nL’hébergeur du site teampeps.fr / teampeps.com est la société O2SWITCH, dont le siège social est situé au Chem. Des Pardiaux, 63000 CLERMONT FERRAND, France, avec le numéro de téléphone : 04 44 44 60 40. ",
				"title": "ARTICLE 1 : LES MENTIONS LÉGALES"
			},
			"article_2": {
				"content": "Le site teampeps.fr / teampeps.com permet à l’Utilisateur un accès gratuit aux services suivants : informations sur la Team Peps et ses membres, calendrier de matchs compétitifs, prise de contact, consultation de contenus, redirection, pronostics.    \n\nLe site est accessible gratuitement en tout lieu à tout Utilisateur ayant un accès à Internet. Tous les frais supportés par l'Utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.   \n\nL'utilisateur non membre n'a pas accès aux services réservés. Pour y accéder, il doit s’inscrire en utilisant l’authentification via Twitch, liant ainsi son compte Twitch. En acceptant de s’inscrire aux services réservés, l’Utilisateur membre s’engage à fournir des informations sincères et exactes concernant son compte Twitch et, le cas échéant, ses coordonnées, notamment son adresse email.   \n\nPour accéder aux services, l’Utilisateur doit s’authentifier à l’aide de son compte Twitch.   \n\nTout utilisateur membre régulièrement inscrit pourra également solliciter sa désinscription en se rendant à la page dédiée sur son espace personnel. Celle-ci sera effective dans un délai raisonnable.   \n\nTout événement dû à un cas de force majeure ayant pour conséquence un dysfonctionnement du site ou serveur et sous réserve de toute interruption ou modification en cas de maintenance, n'engage pas la responsabilité de teampeps.fr et teampeps.com.    \n\nDans ces cas, l’Utilisateur accepte ainsi ne pas tenir rigueur à l’éditeur de toute interruption ou suspension de service, même sans préavis.   \n\nL'utilisateur a la possibilité de contacter le site par messagerie électronique à l’adresse email de l’éditeur communiqué à l’ARTICLE 1. ",
				"title": "ARTICLE 2 : ACCÈS AU SITE"
			},
			"article_3": {
				"content": "Le site assure à l’Utilisateur une collecte et un traitement d’informations personnelles dans le respect de la vie privée conformément à la loi n°78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés.    \n\nEn vertu de la loi Informatique et Libertés, en date du 6 janvier 1978, l’Utilisateur dispose d’un droit d’accès, de rectification, de suppression et d’opposition de ses données personnelles.     \n\nL'Utilisateur exerce ce droit :  \n\n· par mail à l'adresse email contact.teampeps@gmail.com  \n\n· via son espace personnel ; ",
				"title": "ARTICLE 3 : COLLECTE DES DONNÉES"
			},
			"article_4": {
				"content": "Les marques, logos, signes ainsi que tous les contenus du site (textes, images, son…) font l’objet d’une protection par le Code de la propriété intellectuelle et plus particulièrement par le droit d’auteur.   \n\nL’Utilisateur doit solliciter l’autorisation préalable du site pour toute reproduction, publication, copie des différents contenus. Il s’engage à une utilisation des contenus du site dans un cadre strictement privé, toute utilisation à des fins commerciales et publicitaires est strictement interdite. \n\nToute représentation totale ou partielle de ce site par quelque procédé que ce soit, sans l’autorisation expresse de l’exploitant du site Internet constituerait une contrefaçon sanctionnée par l’article L 335-2 et suivants du Code de la propriété intellectuelle. \n\nIl est rappelé conformément à l’article L122-5 du Code la propriété intellectuelle que l’Utilisateur qui reproduit, copie ou publie le contenu protégé doit citer l’auteur et sa source.",
				"title": "ARTICLE 4 : PROPRIÉTÉ INTELLECTUELLE"
			},
			"article_5": {
				"content": "Les sources des informations diffusées sur le site teampeps.fr / teampeps.com sont réputées fiables, mais le site ne garantit pas qu’il soit exempt de défauts, d’erreurs ou d’omissions.    \n\nLes informations communiquées sont présentées à titre indicatif et général sans valeur contractuelle.   \n\nMalgré des mises à jour régulières, le site teampeps.fr / teampeps.com ne peut être tenu responsable de la modification des dispositions administratives et juridiques survenant après la publication. De même, le site ne peut être tenu responsable de l’utilisation et de l’interprétation de l’information contenue dans ce site.   \n\nL'Utilisateur s'assure de garder son mot de passe secret. Toute divulgation du mot de passe, quelle que soit sa forme, est interdite. Il assume les risques liés à l'utilisation de son identifiant et mot de passe. Le site décline toute responsabilité.   \n\nLe site teampeps.fr / teampeps.com ne peut être tenu pour responsable d’éventuels virus qui pourraient infecter l’ordinateur ou tout matériel informatique de l’Internaute, suite à une utilisation, à l’accès, ou au téléchargement provenant de ce site.    \n\nLa responsabilité du site ne peut être engagée en cas de force majeure ou du fait imprévisible et insurmontable d’un tiers. ",
				"title": "ARTICLE 5 : RESPONSABILITÉ"
			},
			"article_6": {
				"content": "Des liens hypertextes peuvent être présents sur le site. L’Utilisateur est informé qu’en cliquant sur ces liens, il sortira du site teampeps.fr / teampeps.com . Ce dernier n’a pas de contrôle sur les pages web sur lesquelles aboutissent ces liens et ne saurait, en aucun cas, être responsable de leur contenu.",
				"title": "ARTICLE 6 : LIENS HYPERTEXTES"
			},
			"article_7": {
				"content": "L’Utilisateur est informé que lors de ses visites sur le site, un cookie peut s’installer automatiquement sur son logiciel de navigation. \n\nLes cookies sont de petits fichiers stockés temporairement sur le disque dur de l’ordinateur de l’Utilisateur par votre navigateur et qui sont nécessaires à l’utilisation du site teampeps.fr / teampeps.com . Les cookies ne contiennent pas d’information personnelle et ne peuvent pas être utilisés pour identifier quelqu’un. Un cookie contient un identifiant unique, généré aléatoirement et donc anonyme. Certains cookies expirent à la fin de la visite de l’Utilisateur, d’autres restent. \n\nL’information contenue dans les cookies est utilisée pour améliorer le site teampeps.fr / teampeps.com . \n\nEn naviguant sur le site, l’Utilisateur les accepte. \n\nL’Utilisateur pourra désactiver ces cookies par l’intermédiaire des paramètres figurant au sein de son logiciel de navigation.",
				"title": "ARTICLE 7 : COOKIES"
			},
			"article_8": {
				"content": "Le site ne permet pas aux membres de publier.",
				"title": "ARTICLE 8 : PUBLICATION PAR L’UTILISATEUR"
			},
			"article_9": {
				"content": "La législation française s’applique au présent contrat. En cas d’absence de résolution amiable d’un litige né entre les parties, les tribunaux français seront seuls compétents pour en connaître. \n\nPour toute question relative à l’application des présentes CGU, vous pouvez joindre l’éditeur aux coordonnées inscrites à l’ARTICLE 1. \n\nEn cas de divergence entre les versions linguistiques des présentes CGU, la version française prévaudra.",
				"title": "ARTICLE 9 : DROIT APPLICABLE ET JURIDICTION COMPÉTENTE"
			},
			"header": "En vigueur au 02/09/2025  \n\nLes présentes conditions générales d’utilisation (dites “CGU”) ont pour objet l’encadrement juridique des modalités de mise à disposition du site et des services par Team Peps et de définir les conditions d’accès et d’utilisation des services par “l’Utilisateur”.   \n\nLes présentes CGU sont accessibles sur le site à la rubrique “CGU”.   \n\nToute inscription ou utilisation du site implique l'acceptation sans aucune réserve ni restriction des présentes CGU par l’utilisateur. Lors de l'inscription sur le site via le Formulaire d’inscription, chaque utilisateur accepte expressément les présentes CGU en cochant la case précédant le texte suivant : «Je reconnais avoir lu et compris les CGU et je les accepte ».   \n\nEn cas de non-acceptation des CGU stipulées dans le présent contrat, l'Utilisateur se doit de renoncer à l'accès des services proposés par le site.   \n\nteampeps.fr / teampeps.com se réserve le droit de modifier unilatéralement et à tout moment le contenu des présentes CGU. ",
			"seo-description": "Les conditions générales d'utilisation du site de la Team Peps.",
			"seo-title": "Team Peps - Conditions générales d'utilisation",
			"title-on-page": "CONDITIONS GÉNÉRALES D’UTILISATION - FR"
		},
		"club": {
			"become-partner": "devenir partenaire",
			"big-text": {
				"a": "une",
				"club": "club",
				"commu": "commu",
				"more": "plus",
				"than": "qu'un"
			},
			"description": "Fondé en 2022 par Féfé la Team Peps était au départ un projet pour mettre en avant la communauté Overwatch française, mais très vite, les choses ont pris une autre dimension. Avec le succès rencontré et une communauté toujours plus engagée, le club a très vite grandi avec l'objectif de s'imposer comme une référence française à l'international. Aujourd'hui, la Team Peps met tout en oeuvre pour aller chercher les titres les plus prestigieux sur Overwatch, et ne compte pas s'arrêter en si bon chemin !",
			"legends": {
				"join-them": "Tu veux les rejoindre ?",
				"title": "Les ultra Peps (LES GOATS !)"
			},
			"second-description": "Que ce soit en tant que fan, en tant que sponsor, ou en tant que simple enthousiaste de l'esport, venez découvrir la Team Peps et sa communauté au travers de nos matchs. Tous commentés et diffusés sur les chaînes de Féfé, Lutti, et le reste de nos ambassadeurs, expérimentez une ambiance digne des plus grands stades pour soutenir nos joueurs dans les plus grandes compétitions esport.",
			"seo-description": "Découvrez la Team Peps : son histoire, ses valeurs, son staff et la communauté qui fait vivre le club depuis 2022.",
			"seo-title": "Team Peps - Le club",
			"stats": {
				"impressions": "impressions",
				"views-live": "vues live/an",
				"views-video": "vues/m"
			},
			"subtitle": "La main sur la peps",
			"support-team-peps": "soutenir la team peps",
			"title": "Team Peps - Club",
			"view-gallery": "Voir la galerie",
			"viewers-text": "viewers uniques/an"
		},
		"galleries": {
			"seo-description": "Les photos de cet événement de la Team Peps.",
			"subtitle": "Les",
			"title-on-page": "Galeries"
		},
		"gallery": {
			"seo-description": "Les photos des événements, compétitions et moments forts de la Team Peps.",
			"seo-title": "Team Peps - Galerie",
			"title": "Team Peps - Galerie"
		},
		"home": {
			"filter": "filtres",
			"goto-news": "tout voir",
			"news": {
				"subtitle": "les",
				"title": "actus"
			},
			"roster": {
				"subtitle": "Les",
				"title": "rosters"
			},
			"seo-description": "Team Peps, club esport français fondé en 2022 par Féfé. Suivez nos équipes Overwatch, Marvel Rivals, Pokémon VGC, Pokémon Unite et Dofus : matchs, actualités, roster et coulisses.",
			"seo-title": "Team Peps - Club esport français",
			"ticketing": {
				"close": "Fermer",
				"title": "Vivons la qualification aux Worlds ensemble !"
			},
			"upcoming-matches": {
				"subtitle": "prochains"
			}
		},
		"hub": {
			"bet": {
				"cta": "Faire un prono",
				"description": "Pronostique sur les matchs de la Team Peps, grimpe au classement et deviens le meilleur analyste.",
				"leaderboard": "Classement",
				"tag": "Pronostics OWCS",
				"title": "Pronos"
			},
			"coins": {
				"description": "La monnaie de l'écosystème",
				"label": "PepsCoins"
			},
			"collection": {
				"cta": "Ouvrir la boutique",
				"description": "Ouvre des boosters, collecte des cartes uniques et échange sur le marché.",
				"inventory": "Inventaire",
				"market": "Marché",
				"shop": "Boutique",
				"tag": "COLLECTION PEPS",
				"title": "Collection"
			},
			"eyebrow": "Accès rapide",
			"quests": {
				"cta": "Voir les missions",
				"description": "Accomplis des défis, gagne des PepsCoins et débloque des récompenses exclusives.",
				"tag": "Saison en cours",
				"title": "Missions"
			},
			"subtitle": "Ton espace Team Peps",
			"title": "PepsBoard"
		},
		"leaderboard": {
			"coming-soon": "A venir",
			"current": "En cours",
			"end-season": "La saison se termine dans :",
			"ended": "La saison est terminée !",
			"make-prediction": "Faire un prono",
			"points": "points",
			"pts": "pts",
			"rank": "rang",
			"title": "Classement",
			"upcoming": "La saison démarre dans :",
			"username": "pseudo"
		},
		"marketplace": {
			"balance": "Solde",
			"buy-modal": {
				"balance-after": "Solde après achat",
				"balance-before": "Solde actuel",
				"cancel": "Annuler",
				"card": "Carte",
				"confirm": "Acheter",
				"error": "Erreur lors de l'achat.",
				"seller": "Vendeur",
				"success": "Carte achetée avec succès !",
				"title": "Confirmer l'achat"
			},
			"description": "Achetez et vendez des cartes avec les autres membres de la communauté.",
			"detail": {
				"card-not-found": "Carte introuvable.",
				"no-sales": "Pas encore de vente pour cette carte.",
				"price": "Prix",
				"price-history": "Historique des prix"
			},
			"edit-price-modal": {
				"cancel": "Annuler",
				"confirm": "Enregistrer",
				"error": "Erreur lors de la modification du prix.",
				"invalid": "Le prix doit être supérieur à 0.",
				"label": "Nouveau prix",
				"success": "Prix mis à jour.",
				"title": "Modifier le prix"
			},
			"filter-all": "Tous",
			"filter-extension-label": "Extension",
			"filter-hide-owned": "Masquer les cartes déjà possédées",
			"filter-price-label": "Prix",
			"filter-price-max": "Max",
			"filter-price-min": "Min",
			"filter-rarity-label": "Raretés",
			"filter-seller-label": "Vendeur",
			"filter-seller-placeholder": "Pseudo...",
			"history": {
				"count": "{{count}} vente(s)",
				"empty": "Aucune vente pour le moment",
				"total-earned": "Total gagné"
			},
			"listing": {
				"buy": "Acheter",
				"cancel": "Annuler",
				"cancel-error": "Erreur lors de l'annulation.",
				"cancel-success": "Vente annulée.",
				"edit-price": "Modifier",
				"own-badge": "Ma vente"
			},
			"load-more": "Charger plus",
			"maintenance": {
				"back": "Retour à la boutique",
				"heading": "Marketplace en maintenance",
				"text": "Le marketplace est temporairement indisponible. Reviens un peu plus tard.",
				"title": "Marketplace — Maintenance"
			},
			"mine": {
				"status-active": "En vente",
				"status-cancelled": "Annulées",
				"status-label": "Statut",
				"status-sold": "Vendues"
			},
			"no-filter-results": "Aucun résultat",
			"no-listings": "Aucune carte disponible",
			"rarity-collector": "Collector",
			"rarity-common": "Commun",
			"rarity-epic": "Épique",
			"rarity-legendary": "Légendaire",
			"rarity-rare": "Rare",
			"search-placeholder": "Rechercher...",
			"sell": "Mettre en vente",
			"sell-modal": {
				"cancel": "Annuler",
				"confirm": "Mettre en vente",
				"error": "Erreur lors de la mise en vente.",
				"no-cards": "Aucun doublon à vendre",
				"no-search-results": "Aucune carte ne correspond à ta recherche",
				"price": "Prix de vente",
				"search-placeholder": "Rechercher une carte...",
				"select-card": "Sélectionner une carte",
				"success": "Carte mise en vente avec succès !",
				"title": "Mettre en vente"
			},
			"sort-label": "Trier par",
			"sort-name": "Nom",
			"sort-price": "Prix",
			"sort-price-asc": "Prix ↑",
			"sort-price-desc": "Prix ↓",
			"sort-rating": "Note",
			"sort-recent": "Récent",
			"subtitle": "BOUTIQUE",
			"tab-history": "Historique des ventes",
			"tab-market": "Marché",
			"tab-mine": "Mes annonces",
			"title": "MARKETPLACE",
			"tutorial": {
				"balance": {
					"text": "Ton solde de PepsCoins, à dépenser sur les cartes en vente. Tu en gagnes en progressant dans le Battle Peps.",
					"title": "Ton solde"
				},
				"demo-badge": "Exemple",
				"demo-buy-disabled": "Ceci est une carte d'exemple, non achetable.",
				"demo-card": {
					"text": "Clique sur une carte pour voir son détail : historique des prix et achat en un clic si tu as assez de PepsCoins.",
					"title": "Une carte en vente"
				},
				"demo-card-name": "CARTE DÉMO",
				"done": "Terminé",
				"header": {
					"text": "Achète et vends des cartes avec les autres joueurs de la Team Peps.",
					"title": "Bienvenue sur le marketplace !"
				},
				"next": "Suivant",
				"prev": "Précédent",
				"rarity-filter": {
					"text": "Filtre les cartes par rareté.",
					"title": "Filtrer par rareté"
				},
				"replay": "Revoir le tutoriel",
				"search": {
					"text": "Recherche une carte par son nom.",
					"title": "Rechercher une carte"
				},
				"sell": {
					"text": "Mets en vente les doublons de ta collection contre des PepsCoins.",
					"title": "Vendre une carte"
				},
				"sort": {
					"text": "Trie les annonces par date, prix ou note.",
					"title": "Trier les annonces"
				},
				"tabs": {
					"text": "Bascule entre le marché et tes propres ventes en cours.",
					"title": "Marché / Mes ventes"
				}
			}
		},
		"matchs": {
			"coming-soon": "à venir",
			"follow-team-peps": "Retrouve la Team Peps sur twitch et youtube",
			"result": "résultats",
			"seo-description": "Le calendrier complet de la Team Peps : prochains matchs, résultats et événements sur Overwatch, Marvel Rivals, Pokémon VGC, Pokémon Unite et Dofus.",
			"seo-title": "Team Peps - Matchs et événements",
			"title": "Team Peps - Matchs",
			"today": "aujourd'hui",
			"view-score": "Voir les scores"
		},
		"member-details": {
			"age": "âge: {{age}} ans",
			"country": "pays",
			"roster": "roster",
			"seo-description": "Découvrez le parcours, le palmarès et les réseaux de ce joueur de la Team Peps.",
			"the": "le"
		},
		"news": {
			"filter-toast": "Vous devez garder au moins une catégorie d'article sélectionnée.",
			"seo-description": "Toute l'actualité de la Team Peps : résultats de matchs, transferts, annonces de roster et coulisses du club esport.",
			"seo-title": "Team Peps - Actualités",
			"title": "Team Peps - Les Actus"
		},
		"news-details": {
			"next": "Actu suivante",
			"previous": "Actu précédente",
			"publish-at": "Publié le :",
			"react": "Réagir",
			"see-all-news": "Voir toutes les actus",
			"seo-description": "Lisez l'actualité complète de la Team Peps."
		},
		"not-found": {
			"seo-description": "Cette page n'existe pas ou a été déplacée.",
			"seo-title": "Team Peps - Page introuvable",
			"text-1": "Bon, te casse pas la Peps, mais ce que tu cherches n'existe pas.",
			"text-2": "(Voilà c'est dit)",
			"title": "Team Peps - Page introuvable"
		},
		"partners": {
			"contact-us": "Nous contacter",
			"partner-minor": {
				"subtitle": "Nos autres",
				"title": "partenaires"
			},
			"seo-description": "Les partenaires et sponsors qui accompagnent la Team Peps dans ses compétitions esport.",
			"seo-title": "Team Peps - Partenaires",
			"subtitle": "nos",
			"title": "Team Peps - Partenaires",
			"title-on-page": "partenaires"
		},
		"place": {
			"buttons": {
				"back": "Quitter le pplace",
				"challenges": "Défis",
				"coming-soon": "Bientôt disponible",
				"download": "Télécharger la toile",
				"draw": "Dessiner",
				"leaderboard": "Classement",
				"open-color-selector": "Ouvrir le sélecteur de couleurs",
				"selected-color": "Couleur sélectionnée",
				"validated-pixels": "Valider les pixels posés",
				"what-is-pplace": "C'est quoi PPLACE ?"
			},
			"pixel-info": {
				"draw-by": "Peint par",
				"no-draw": "Personne n'a peint ce pixel"
			},
			"pixels": {
				"error": "Impossible de placer les pixels",
				"validated": "Vous avez placé {{count}} pixels"
			}
		},
		"place-leaderboard": {
			"pixels": "Pixels posé",
			"rank": "Rang",
			"username": "Pseudo"
		},
		"privacy": {
			"article_1": {
				"content": "L’édition du Site est assurée par la « Team Peps », enregistrée à l’INPI sous le numéro 5075453. \n\nContact et demandes relatives aux données personnelles : contact.teampeps@gmail.com \n\nHébergeur : O2SWITCH, Chem. des Pardiaux, 63000 Clermont-Ferrand, France — 04 44 44 60 40. \n\nLe responsable du traitement au sens du RGPD est la Team Peps, joignable à l’adresse e-mail ci-dessus.",
				"title": "ARTICLE 1 : RESPONSABLE DU TRAITEMENT"
			},
			"article_10": {
				"content": "Le Site met en œuvre des mesures techniques et organisationnelles raisonnables pour protéger les données contre tout accès, modification ou divulgation non autorisés (communications chiffrées en HTTPS, contrôle des accès, hébergement en France). \n\nLa présente politique peut être modifiée pour refléter des évolutions légales ou techniques. La version en vigueur est celle publiée sur cette page ; sa date d’entrée en vigueur figure en tête de document. En cas de divergence entre les versions linguistiques, la version française prévaut.",
				"title": "ARTICLE 10 : SÉCURITÉ ET MODIFICATIONS"
			},
			"article_2": {
				"content": "Le Site ne stocke qu’un ensemble limité de données : \n\n· Compte Twitch (obligatoire pour l’inscription) : l’identifiant Twitch, le pseudo Twitch et l’image de profil (avatar) Twitch. \n\n· Compte Discord (uniquement si l’utilisateur choisit de lier son compte Discord) : l’identifiant Discord, le pseudo Discord et l’image de profil (avatar) Discord. \n\n· Données de jeu générées sur le Site et rattachées au compte : progression et points d’expérience (XP) du programme BattlePeps, cartes de collection, pronostics. \n\nLe Site ne stocke aucune adresse e-mail. \n\nLe Site ne stocke aucune donnée provenant de Google ou de YouTube (voir ARTICLES 3 et 4) : le compte Google n’est jamais lié ni enregistré. \n\nBase légale : exécution du contrat (fourniture des services réservés) et intérêt légitime de la Team Peps à animer sa communauté.",
				"title": "ARTICLE 2 : DONNÉES COLLECTÉES ET STOCKÉES"
			},
			"article_3": {
				"content": "Le Site propose une quête « S’abonner sur YouTube » dans le cadre du programme BattlePeps. Pour la valider, l’utilisateur choisit librement de se connecter avec son compte Google via le protocole OAuth 2.0. \n\nChamp d’application (« scope ») demandé : « https://www.googleapis.com/auth/youtube.readonly » (lecture seule des données YouTube). \n\nDonnée effectivement consultée : uniquement l’existence, ou non, d’un abonnement de l’utilisateur à la chaîne YouTube de fefegg, au moyen de l’appel « subscriptions.list » (paramètre mine=true) de l’API YouTube Data v3. \n\nFinalité unique : vérifier l’accomplissement de la quête et créditer les points d’expérience (XP) correspondants sur le compte membre. \n\nDéclenchement : exclusivement à l’initiative de l’utilisateur, au moment où il clique sur « Valider » la quête. Aucune consultation des données Google n’a lieu en dehors de cette action.",
				"title": "ARTICLE 3 : DONNÉES GOOGLE / YOUTUBE"
			},
			"article_4": {
				"content": "Aucune donnée issue du compte Google n’est conservée par le Site. Le jeton d’accès OAuth Google est utilisé une seule fois, côté serveur, pour lire le statut d’abonnement décrit à l’ARTICLE 3, puis immédiatement supprimé. Le Site ne demande ni ne reçoit de jeton d’actualisation (« refresh token »). \n\nNe sont conservés ni le jeton d’accès, ni les informations de profil Google (nom, adresse e-mail, photo), ni la liste des abonnements. Seul un identifiant technique temporaire de sécurité (valeur « state » servant à prévenir les attaques CSRF) transite dans la base de données et est supprimé dès le retour de l’utilisateur sur le Site. \n\nSeul le résultat métier est conservé : le fait que la quête a été validée et l’XP créditée, rattachés au compte membre.",
				"title": "ARTICLE 4 : ABSENCE DE CONSERVATION DES DONNÉES GOOGLE"
			},
			"article_5": {
				"content": "Les données utilisateur obtenues via les services API de Google ne sont ni vendues, ni louées, ni partagées, ni transférées à des tiers. \n\nElles ne sont pas utilisées à des fins publicitaires, ni pour du profilage, ni pour entraîner des modèles d’intelligence artificielle. \n\nL’utilisation et le transfert par le Site des informations reçues des API Google respectent la Règle relative aux données utilisateur des services API Google (« Google API Services User Data Policy »), y compris ses exigences d’utilisation limitée (« Limited Use »).",
				"title": "ARTICLE 5 : PARTAGE ET UTILISATION LIMITÉE"
			},
			"article_6": {
				"content": "L’utilisateur peut retirer à tout moment l’autorisation accordée au Site depuis la page « Applications tierces avec accès au compte » de son compte Google : https://myaccount.google.com/permissions. \n\nAucune donnée Google n’étant conservée, cette révocation n’implique aucune suppression supplémentaire côté Site. Une quête déjà validée reste acquise.",
				"title": "ARTICLE 6 : RÉVOCATION DE L’ACCÈS GOOGLE"
			},
			"article_7": {
				"content": "Le Site utilise des cookies et le stockage local du navigateur strictement nécessaires à son fonctionnement (session d’authentification, préférences d’affichage, langue) ainsi qu’un outil de mesure d’audience. Ces cookies ne contiennent pas d’information permettant d’identifier directement l’utilisateur. \n\nL’utilisateur peut configurer ou désactiver les cookies depuis les paramètres de son navigateur ; certaines fonctionnalités peuvent alors être dégradées.",
				"title": "ARTICLE 7 : COOKIES ET STOCKAGE LOCAL"
			},
			"article_8": {
				"content": "Données du compte membre (identité Twitch, et Discord si le compte a été lié ; activité BattlePeps, collection, pronostics) : conservées tant que le compte existe, puis supprimées ou anonymisées dans un délai raisonnable après la suppression du compte. \n\nDonnées Google / YouTube : aucune (rien n’est stocké, cf. ARTICLE 4). \n\nJournaux techniques : conservés pour une durée limitée à des fins de sécurité et de diagnostic.",
				"title": "ARTICLE 8 : DURÉE DE CONSERVATION"
			},
			"article_9": {
				"content": "Conformément au Règlement général sur la protection des données (RGPD) et à la loi n°78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés, l’utilisateur dispose des droits d’accès, de rectification, d’effacement, de limitation, d’opposition et de portabilité de ses données. \n\nCes droits s’exercent : \n\n· par e-mail à contact.teampeps@gmail.com ; \n\n· depuis l’espace personnel du Site, qui permet notamment de demander la suppression du compte. \n\nL’utilisateur dispose également du droit d’introduire une réclamation auprès de la CNIL (www.cnil.fr).",
				"title": "ARTICLE 9 : DROITS DES UTILISATEURS"
			},
			"header": "En vigueur au 30/08/2026 \n\nLa présente politique de confidentialité décrit comment la Team Peps collecte, utilise, conserve et protège les données à caractère personnel des utilisateurs du site teampeps.fr / teampeps.com (ci-après « le Site »), y compris les données obtenues via les services API de Google. Elle complète les Conditions Générales d’Utilisation. \n\nEn utilisant le Site, l’utilisateur reconnaît avoir pris connaissance de la présente politique.",
			"seo-description": "La politique de confidentialité et de traitement des données personnelles de la Team Peps.",
			"seo-title": "Team Peps - Confidentialité",
			"title-on-page": "POLITIQUE DE CONFIDENTIALITÉ - FR"
		},
		"profile": {
			"account": {
				"danger-description": "Cette action est irréversible et supprime toutes vos données.",
				"danger-zone": "Zone dangereuse",
				"delete-btn": "Supprimer",
				"discord-label": "Discord",
				"discord-link-btn": "Lier Discord",
				"discord-link-error": "Impossible de démarrer la liaison Discord.",
				"discord-linked-success": "Votre compte Discord a été lié !",
				"discord-unlink-btn": "Délier",
				"discord-unlink-error": "Impossible de délier votre compte Discord.",
				"discord-unlink-success": "Votre compte Discord a été délié.",
				"info-title": "Informations",
				"username-label": "Pseudo"
			},
			"achievements": {
				"empty": "Aucun haut fait pour l'instant",
				"title": "Hauts faits"
			},
			"boosters-opened-label": "Boosters ouverts",
			"date": "Date",
			"delete-account": {
				"button": "Supprimer le compte",
				"cancel": "Rester soutenir l'équipe",
				"confirm": "Supprimer le compte",
				"error": "Impossible de supprimer ton compte, rapproche toi du staff sur le discord de l'équipe !",
				"success": "Ton compte à été supprimé, la communauté a perdu un fervant supporter.",
				"text": "Tu es sur le point de supprimer ton compte. Cette action est irreversible et effacera toutes tes données (statistiques, classements et participations) !",
				"text-second": "FDGod et toute la team comptent sur toi… es-tu vraiment sûr de vouloir partir ?",
				"title": "Suppression de ton compte"
			},
			"favorites": {
				"description": "Mets en avant 5 cartes de ta collection. Elles seront visibles sur ton profil public. Glisse-dépose une carte sur un slot, ou clique dessus pour la placer sur le premier slot libre.",
				"error": "Erreur lors de la mise à jour des favoris.",
				"no-cards": "Tu n'as aucune carte à mettre en favori",
				"pool-label": "Tes cartes",
				"reset": "Réinitialiser",
				"save": "Enregistrer",
				"section-title": "Cartes favorites",
				"slot-empty": "Slot",
				"success": "Favoris mis à jour !"
			},
			"inventory": {
				"detail": {
					"destroy-button": "Détruire",
					"destroy-confirm": "Confirmer",
					"destroy-confirm-message": "Action irréversible — la carte sera détruite en échange de {{coins}} PepsCoins.",
					"destroy-error": "Erreur lors de la destruction de la carte.",
					"destroy-success": "Carte détruite — +{{coins}} PepsCoins !",
					"sell-button": "Mettre en vente",
					"view-details": "Voir les détails"
				},
				"filter-all": "Tous",
				"filter-rarity-label": "Rareté",
				"no-boosters": "Aucun booster à ouvrir",
				"no-cards": "Aucune carte pour l'instant",
				"no-filter-results": "Aucune carte ne correspond aux filtres",
				"rarities-tooltip": "Raretés disponibles : ",
				"rarity-collector": "Collector",
				"rarity-common": "Commun",
				"rarity-epic": "Épique",
				"rarity-legendary": "Légendaire",
				"rarity-rare": "Rare",
				"search-placeholder": "Rechercher...",
				"section-boosters": "Boosters",
				"section-cards": "Cartes",
				"show-not-owned": "Voir les cartes non possédées",
				"sort-direction-asc": "Croissant",
				"sort-direction-desc": "Décroissant",
				"sort-label": "Trier par",
				"sort-name": "Nom",
				"sort-rarity": "Rareté",
				"sort-score": "Score"
			},
			"match": "Match",
			"no-prediction": "Tu n'as fait aucun prono jusqu'a maintenant !",
			"open": "Ouvrir",
			"overview": {
				"challenge-pplace-completed": "Défis pplace complété"
			},
			"perfect": "Perfect",
			"points": "points",
			"points-earned": "Gains",
			"rank": "Rang",
			"result": "Résultat",
			"result-soon": "A venir",
			"soon-earn": "A venir",
			"tab": {
				"account": "Compte",
				"achievements": "Hauts Faits",
				"favorites": "Favoris",
				"inventory": "Inventaire",
				"predictions": "Pronostics"
			},
			"tab-bet": {
				"bet-history-title": "Historique des pronos",
				"bet-stats-title": "Statistiques"
			},
			"tab-choice": {
				"bet": "Pronostics",
				"overview": "Aperçu",
				"place": "pPlace"
			},
			"tab-overview": {
				"badge-title": "Badges"
			},
			"tab-place": {
				"challenges-title": "Défis",
				"connection-streak": "jours consécutifs",
				"pixels-placed": "pixels posés",
				"stats-title": "Statistiques"
			},
			"total-bet": "Pronos",
			"total-lost": "Echoué",
			"total-won": "Réussi",
			"your-prediction": "Ton prono"
		},
		"public-profile": {
			"badges-title": "Badges",
			"compare-perfects": "Scores parfaits",
			"compare-title": "Face-à-face",
			"compare-winrate": "Taux de réussite",
			"compare-won": "Pronos gagnés",
			"compare-you": "Toi",
			"favorites-title": "Cartes favorites",
			"listings-title": "Cartes en vente",
			"member-since": "Membre depuis",
			"no-favorites": "Aucune carte mise en avant",
			"no-listings": "Aucune carte en vente",
			"no-predictions": "Aucun pronostic pour le moment",
			"no-rank": "Pas de progression",
			"prediction-status": {
				"lost": "Perdu",
				"pending": "En attente",
				"won": "Gagné"
			},
			"rank-history-title": "Historique de rang BattlePeps",
			"recent-predictions-title": "Derniers pronostics",
			"recently-live": "Vu récemment en live",
			"stat-badges": "Badges",
			"stat-boosters": "Boosters ouverts",
			"stat-favorites": "Cartes favorites",
			"stat-listings": "Cartes en vente",
			"stat-quests": "Quêtes validées",
			"stat-seasons": "Saisons jouées",
			"stats-title": "En bref",
			"validated-quests": "quêtes BattlePeps validées"
		},
		"quests": {
			"battle-peps": "BATTLE PEPS",
			"brigade": {
				"name": "La Brigade de Véro",
				"title": "Utilise le code Peps sur ta prochaine commande !"
			},
			"brigade-completed": "Mission accomplie !",
			"brigade-description": "La Brigade de Véro nous a donné une mission : atteindre les 35 commandes avant la fin de la soirée Peps ! Un maillot Team Peps 2026 signé par les joueurs à gagner.",
			"coming-soon": "À venir",
			"discord": "Être informé du lancement",
			"discord-quest": {
				"title": "Rejoins le Discord Team Peps !"
			},
			"discord-quest-description": "Intègre le serveur Discord officiel de la Team Peps et rejoins une communauté passionnée d'esport.",
			"instagram": {
				"title": "Suis la Team Peps sur Instagram !"
			},
			"instagram-description": "Abonne-toi à notre Instagram pour ne manquer aucune actualité et tous les behind-the-scenes de la Team.",
			"not-verified": "Non vérifié",
			"objectives": "objectifs",
			"progress": "Progression de la saison",
			"reward": "Récompense",
			"rewards": "Récompenses",
			"season": "Saison 1",
			"timer": {
				"text": "Fin dans :"
			},
			"twitch": {
				"title": "Abonne-toi à la chaîne Twitch !"
			},
			"twitch-description": "Rejoins la communauté Team Peps sur Twitch et ne rate aucun live, tournoi ou soirée Peps !",
			"x": {
				"name": "le pack razer",
				"title": "Soutiens la PEPS sur X !"
			},
			"x-description": "Si on arrive à 1500 interactions sur le post d'annonce du roster OWCS 2026, on vous fait gagner un pack Razer complet ! (Free Poulet autorisé)",
			"youtube": {
				"title": "Abonne-toi à la chaîne YouTube !"
			},
			"youtube-description": "Retrouve tous les highlights, interviews et contenus exclusifs de la Team Peps sur YouTube."
		},
		"roster": {
			"academy": {
				"description": "L'Academy c'est notre programme pour dénicher les futurs talents de la scène Overwatch ! L'objectif : découvrir et faire découvrir les Pépites qui domineront la scène compétitive dans le futur. Restez à l'affût pour les prochaines sessions de Tests, c'est peut-être VOUS la future pépite !",
				"join-faceit": "Rejoignez l'Academy sur FACEIT",
				"title": "L'academy, c'est quoi ?"
			},
			"dofus": {
				"seo-description": "Le roster Dofus de la Team Peps : joueurs, compositions et palmarès en tournoi.",
				"seo-title": "Team Peps - Roster Dofus"
			},
			"leaderboard": {
				"col-draw": "Nuls",
				"col-lost": "Défaites",
				"col-played": "Joués",
				"col-pts": "Points",
				"col-rank": "#",
				"col-team": "Équipe",
				"col-won": "Victoires",
				"subtitle": "SAISON EN COURS",
				"title": "CLASSEMENT"
			},
			"marvel-rivals": {
				"seo-description": "Le roster Marvel Rivals de la Team Peps : joueurs, rôles et palmarès en compétition.",
				"seo-title": "Team Peps - Roster Marvel Rivals"
			},
			"overwatch-academy": {
				"seo-description": "Le roster Overwatch Academy de la Team Peps : la relève du club, joueurs et palmarès.",
				"seo-title": "Team Peps - Roster Overwatch Academy"
			},
			"overwatch-pro": {
				"seo-description": "Le roster Overwatch professionnel de la Team Peps : joueurs, rôles, palmarès et staff engagés en OWCS EMEA.",
				"seo-title": "Team Peps - Roster Overwatch Pro"
			},
			"pokemon": {
				"vgc": {
					"partner": {
						"description": "realme est la marque N°1 pour le Gaming Mobile avec une technologie et des performances de pointe. Celle-ci accompagne la Team Peps dans sa nouvelle aventure sur la scène Pokémon avec l'envie de vivre les plus belles expériences compétitives !",
						"subtitle": "nos",
						"title": "partenaires pokemon"
					}
				}
			},
			"pokemon-unite": {
				"seo-description": "Le roster Pokémon Unite de la Team Peps : joueurs, rôles et palmarès en compétition.",
				"seo-title": "Team Peps - Roster Pokémon Unite"
			},
			"pokemon-vgc": {
				"seo-description": "Le roster Pokémon VGC de la Team Peps : joueurs, résultats et palmarès sur le circuit officiel.",
				"seo-title": "Team Peps - Roster Pokémon VGC"
			},
			"seo-description": "Découvrez le roster de la Team Peps : joueurs, staff et palmarès.",
			"sport": {
				"seo-description": "La section sport de la Team Peps avec Féfé et Benbest.",
				"seo-title": "Team Peps - Section Sport"
			}
		},
		"roster-pokemon-unite": {
			"story-1": {
				"label": "Les débuts",
				"text": "L’histoire de la Team Peps sur Pokémon Unite a démarré en 2023\nDès sa première participation à un tournoi régional, notre roster passe aisément les phases de poules en terminant 1er, et va jusqu’à se hisser en Grande Finale ! Une performance qui nous a permis de nous qualifier aux Championnats du Monde de Yokohama, quelques mois plus tard.\nCette première année a permis d’affirmer d’emblée notre présence au plus haut niveau sur la scène internationale."
			},
			"story-2": {
				"label": "Le sacre",
				"text": "L’année 2026 a été celle de la performance : quelques mois après l’annonce de notre retour, nos joueurs décrochent le sacre de Champions au Major EUIC à Londres après une domination des phases de groupes puis des playoffs !\nLa Team Peps est ainsi devenue la seule équipe européenne de l’histoire à gagner un Major sur le jeu. Cette victoire nous a permis de nous qualifier directement aux Worlds la même année, pour notre deuxième participation."
			},
			"thanks": "Merci à nos joueurs d'avoir marqué la Team Peps à jamais"
		},
		"roster-sport": {
			"padel": {
				"description": "C’est le début de la section sport de la Team Peps !  \n\nL’histoire entre Féfé et le sport s’écrit maintenant depuis des années, et l’objectif a toujours été de l’intégrer dans la Team Peps. C’est chose faite, grâce à vous et vos dons pendant le Zevent 2026  \n\nL’objectif pour Féfé et Benbest est simple : atteindre le top 10 000 français au padel. \nVous pourrez suivre les jours de compétitions sur leurs réseaux sociaux & retrouver le classement actualisé sur le site de la Team Peps.",
				"title": "Classement"
			}
		},
		"shop": {
			"balance": "Solde",
			"buy": "Acheter",
			"catalog": {
				"empty": "Aucun booster disponible pour le moment.",
				"title": "Nos boosters"
			},
			"description": "Ouvre des boosters pour obtenir des cartes collectors de tes joueurs préférés.",
			"feature": {
				"cards": "{{ count }} cartes par booster",
				"duplicates": "Il est possible d'obtenir des cartes déjà possédées"
			},
			"insufficient": "Fonds insuffisants",
			"login-required": "Connexion requise",
			"modal": {
				"balance-after": "Solde après achat",
				"cancel": "Annuler",
				"confirm": "Acheter",
				"quantity": "Quantité",
				"title": "Confirmer",
				"total": "Total"
			},
			"purchase": {
				"error": "Une erreur est survenue lors de l'achat du booster. Veuillez réessayer.",
				"success": "Booster acheté avec succès !"
			},
			"subtitle": "BOUTIQUE",
			"title": "BOOSTER"
		}
	}
}
